import { BaseChartOptions, HighchartsOptions } from './highcharts-options';

/**
 * @deprecated Please use {@link ChartOptionsBuilder}
 */
export default class ExplanationChartOptions {
  /**
   * @deprecated Please use {@link ChartOptionsBuilder}
   */
  static getChartOptions(): HighchartsOptions {
    const baseOptions = BaseChartOptions.getEmptyChartOptions();
    const chartOptions: HighchartsOptions = {
      ...baseOptions,
      chart: {
        type: 'bar',
        marginLeft: 200,
      },
      plotOptions: {
        series: {
          animation: false,
        },
      },
      title: {
        text: '',
      },
      xAxis: {
        ...baseOptions.xAxis,
        categories: [],
        min: 0,
        max: 9,
        scrollbar: {
          enabled: true,
          showFull: false,
        },
        labels: {
          reserveSpace: true,
          style: {
            width: 150, // Set maximum width of the labels
            whiteSpace: 'normal', // Allow text wrapping
            textOverflow: 'none', // Prevent text truncation
          },
        },
      },
      yAxis: {
        title: {
          text: '',
        },
        min: 0,
        max: 100,
      },
      legend: {
        enabled: true,
      },
      exporting: {
        enabled: false,
      },
      credits: {
        text: 'pacemaker.ai',
        href: ' https://pacemaker.ai/',
      },
      tooltip: {
        useHTML: true,
        headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
        pointFormat:
          '<tr><td style="color: {series.color}">{series.name} </td>' +
          '<td style="text-align: right"><b>{point.y}</td></tr>',
        footerFormat: '</table>',

        shared: true,
      },
      series: [],
    };

    return chartOptions;
  }

  /**
   * Sets the max value of the x axis to the amount of bars to display. If there are fewer bars than the maxDisplayedBars, the max value of the x axis is set to the amount of bars.
   * This is neccessary to avoid filling up the categories with numbers and empty bars until the max value is reached.
   * @param config
   * @param maxDisplayedBars
   */
  static patchAmountOfBarsToDisplay(
    config: HighchartsOptions,
    maxDisplayedBars: number,
  ): HighchartsOptions {
    const patchedConfig = config;
    if (config.series.length > 0 && config.series[0].type === 'bar') {
      const barsCount = config.series[0].data?.length ?? 0;
      const amountOfBars =
        barsCount > maxDisplayedBars ? maxDisplayedBars : barsCount;

      patchedConfig.xAxis.max = amountOfBars > 0 ? amountOfBars - 1 : null;
    }
    return patchedConfig;
  }
}
